import React from 'react';
import Input from '../../Input';

const PasswordInput = ({ value }) => {
  return (
    <Input
      labelName={'Senha'}
      type={'password'}
      value={value}
      disabled
      marginTop={0}
    />
  );
};

export default PasswordInput;
